import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";

const advancePaymentsApi = factory.get("advance_payments");

const initialState = {
  results: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      department_id: null,
      start_date: null,
      end_date: null,
      user_id: null,
      is_new: null,
    },
    filters_dialog: false,
  },
  status: [
    { id: 1, ar_name: "في الانتظار", en_name: "new", color: "warning" },
    { id: 2, ar_name: "موافقة", en_name: "Accept", color: "success" },
    { id: 3, ar_name: "مرفوضة", en_name: "Reject", color: "error" },
  ],
  typeList: [
    { id: "bonus", label: "مكافأة" },
    { id: "deduction", label: "خصم" },
  ],
  advance_payments: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      user_id: null,
      amount: null,
      partial_amount: null,
      deduction: null,
      remaining: null,
    },
  },
};

export const advancePayments = createSlice({
  name: "advancePayments",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setDialog: (state, action) => {
      state.advance_payments.dialog = !state.advance_payments.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.results.data = payload.data.data;
      state.results.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      for (const key in state.advance_payments.form) {
        if (payload[key]) {
          state.advance_payments.form[key] = payload[key];
        }
      }
      state.advance_payments.form.user_id = {
        id: payload.user_id,
        full_name: payload.user_name,
        department_name: payload.department,
      };
    },
    resetForm: (state, action) => {
      state.advance_payments.form = initialState.advance_payments.form;
    },
    setFiltersDialog: (state, action) => {
      state.results.filters_dialog = !state.results.filters_dialog;
    },
    setFilters: (state, { payload }) => {
      state.results.filters = {
        ...state.results.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.results.filters = initialState.results.filters;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setDataTable,
  setById,
  resetForm,
  setFilters,
  setFiltersDialog,
  resetFilters,
} = advancePayments.actions;

export default advancePayments.reducer;
const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};
//axios
const getAll = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("results"));
    const filters = getState().advancePayments.results.filters;
    const filters_ = {
      ...filters,
      user_id: filters.user_id?.id || null,
      department_id: filters.department_id?.id || null,
    };
    const res = await advancePaymentsApi.getAll(filters_);
    dispatch(setDataTable(res));
    dispatch(setLoading("results"));
  } catch (err) {
    dispatch(setLoading("results"));
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await advancePaymentsApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف  بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("results"));
    const res = await advancePaymentsApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("results"));
  } catch (err) {
    dispatch(setLoading("results"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("advance_payments"));

    const form = {
      user_id: data.user_id?.id,
      amount: toNumber(data.amount),
      deduction: toNumber(data.deduction),
      remaining: toNumber(data.remaining),
    };
    await advancePaymentsApi.create(form);
    dispatch(setLoading("advance_payments"));
    dispatch(
      showNotification({
        message: "تم الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("advance_payments"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("advance_payments"));
    const form = {
      id: data.id,
      user_id: data.user_id?.id,
      amount: toNumber(data.amount),
      deduction: toNumber(data.deduction),
      remaining: toNumber(data.remaining),
    };
    await advancePaymentsApi.update(form);
    dispatch(setDialog());
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("advance_payments"));
  } catch (err) {
    dispatch(setLoading("advance_payments"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const partialPay = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("advance_payments"));
    const form = {
      amount: toNumber(data.partial_amount),
      id: data.id,
    };
    await advancePaymentsApi.partialPay(form);
    dispatch(setDialog());
    dispatch(
      showNotification({
        message: "تم الدفع بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("advance_payments"));
  } catch (err) {
    dispatch(setLoading("advance_payments"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const AdvancePayments = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  partialPay,
};
